import HttpFactory from '../factory'

class AuthFactorsModule extends HttpFactory<any[]> {
  private RESOURCE = '/authentication-factors'
  async get(personId: any): Promise<any> {
    const result = await this.call<any>('GET', `${this.RESOURCE}?personId=${personId}`)
    return result
  }

  async save(contactPointId: any): Promise<any> {
    const result = await this.call<any>('POST', `${this.RESOURCE}`, { contactPointId })
    return result
  }

  async delete(factorId: any, revisionId: any): Promise<any> {
    const result = await this.call<any>('DELETE', `${this.RESOURCE}/${factorId}?revision=${revisionId}`)
    return result
  }
}

export default AuthFactorsModule
